<template lang="pug">
  div(
    class="full-width"
    :key="id"
  )
    
    v-layout(wrap ma-2)

      v-flex#top-bar(xs12)
        v-layout(justify-space-between)
          v-flex.text-xs-left.mr-2(shrink)
            img(:src="icon" height=30)
          v-flex.text-xs-left
            template(v-for="t in topLeftSubtext")
              span(:key="t").grey--text {{ t }}
              br
          v-flex.text-xs-right.grey--text
            template(v-for="t in topRight")
              span(:key="t").grey--text {{ t }}
              br

      v-flex#status-body.mt-4.mb-5(xs12)
        //Activity
        v-layout
          v-flex.text-xs-left.title.mt-2
            v-expansion-panel.custom(
              v-if="activity && activity.length > 1"
              inset
            )
              v-expansion-panel-content
                div(slot="header")
                  span(v-html="activity[0][1]")
                  |  on {{ activity[0][0] }}
                v-card
                  v-card-text
                    ul.pl-3
                      li.grey--text(
                        v-for="event in activity.slice(1)"
                      )
                        p
                          span(v-html="event[1]")
                          |  on {{ event[0] }}
            div(v-else-if="activity && activity.length === 1")
              span(v-html="activity[0][1]")
              |  on {{ activity[0][0] }}
            div(v-else v-html="latestActivity")

        //Details
        v-layout.pa-2(
          v-if="details.length > 0"
          column class="field"
        )
          v-flex(xs12 v-for="detail in details" :key="detail.key")
            v-layout(
              v-if="details[detail.key] !== null"
              row align-center
            )
              v-flex.key(
                v-if="$vuetify.breakpoint.xs"
                xs3
              ) {{ detail.short }}
              v-flex.key(
                v-else
                sm2
              ) {{ detail.long }}
              v-flex.val(
                xs7 sm10
                :class="detail.class"
              ) {{ detail.val }}
          span(
            :style="$vuetify.breakpoint.smAndUp ? 'margin-left: 17%' : 'margin-left: 25%'"
          )
            a(
              href="#"
              @click="open()"
              v-show="authorized"
            ) Manage Images
          span
            v-img.loader(
              v-if="loading"
              :src="loadSpinner"
              max-width="300px"
            )

      //Call to actions
      v-flex#ctas-bar(xs12)
        v-layout(row justify-end wrap)
          v-flex.text-xs-right(
            v-for="cta in ctas" :key="cta.key"
            shrink
          )
            //Links
            v-btn.mr-0(
              v-if="cta.type === 'link'"
              :href="cta.href"
              :target="cta.target"
              flat outline :color="cta.color ? cta.color : 'secondary'"
            )
              v-icon.mr-3(
                v-if="cta.hasOwnProperty('icon')"
              ) {{cta.icon}}
              | {{ cta.label }}
            //Actions
            v-btn.mr-0(
              v-else-if="cta.type === 'action'"
              @click.stop="cta.action"
              flat outline :color="cta.color ? cta.color : 'secondary'"
            )
              v-icon.mr-3(
                v-if="cta.hasOwnProperty('icon')"
              ) {{cta.icon}}
              | {{ cta.label }}
      //- Image Uploads Dialog
      UploadsDialog(
        :applicationId="id"
        :uploadsDialog="uploadsDialog"
        @close="close()"
        :lender="lender"
      )
    v-divider
</template>

<script>
  import UploadsDialog from 'Components/UploadsDialog.vue'

  export default {
    name: 'application-list-tile',
    props: {
      id: String,
      latestActivity: String,
      loading: Boolean,
      icon: String,
      ctas: Array,
      activity: Array,
      authorized: Boolean,
      details: {
        type: Array,
        default: () => ([])
      },
      topRight: Array,
      topLeftSubtext: Array,
      lender: String
    },
    data: () => ({
      loadSpinner: require('Assets/blueLoadingSpinner.gif'),
      uploadsDialog: false
    }),
    components: {
      UploadsDialog
    },
    methods: {
      open() {
        console.log('Opening Uploads')
        this.uploadsDialog = true
      },
      close() {
        console.log('Closing Uploads')
        this.uploadsDialog = false
      },
    }
  }
</script>

<style scoped lang="scss">

  .loader {
    margin: auto;
  }

  .field {
    text-align: left;

    .key {
      color: rgba(0,0,0,0.5);
    }

    .val {
      //font-weight: 600;
      color: rgba(0,0,0,0.5);
      font-size: 1.15em;
    }

    background-color: #ECEFF1;
    //margin: 0.5em 1.1em;
  }

  .cta >>> .v-btn__content {
    font-weight: 900;
    padding-left: 0;
    font-size: 1.2em;
  }

  .custom.v-expansion-panel--inset .v-expansion-panel__container {
    max-width: 100%!important;

    &.v-expansion-panel__container--active {
      box-shadow: none;
    }
  }

</style>

<style>
  .v-expansion-panel__header {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
</style>
